"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveModelControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class SaveModelControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error('Parent element (saveModel) is undefined');
        }
        const element = this.createElement();
        parentEl.appendChild(element.domEl);
    }
    dispose() {
        delete this.saveModelBtn;
    }
    start() {
        var _a, _b;
        (_a = this.saveModelBtn) === null || _a === void 0 ? void 0 : _a.addAttribute('disabled', '');
        (_b = this.saveModelBtn) === null || _b === void 0 ? void 0 : _b.addClass('saving');
    }
    stop() {
        var _a, _b;
        (_a = this.saveModelBtn) === null || _a === void 0 ? void 0 : _a.removeAttribute('disabled');
        (_b = this.saveModelBtn) === null || _b === void 0 ? void 0 : _b.removeClass('saving');
    }
    createElement() {
        this.savingSpan = this.createSpan()
            .addClass('saving')
            .addAttribute('data-i18n-key', 'SAVING')
            .addAttribute('data-i18n-attr', `title=SAVING`);
        this.saveModelBtn = this.createButton('SAVE_SETTINGS');
        this.saveModelBtn.domEl.appendChild(this.savingSpan.domEl);
        return new UiElements_1.DivEl()
            .setId('footerControls')
            .addChild(this.saveModelBtn);
    }
    createButton(tooltip) {
        return new UiElements_1.ButtonEl()
            .setId('saveBtn')
            .addChild(new UiElements_1.SpanEl()
            .addAttribute('data-i18n-key', tooltip)
            .addAttribute('data-i18n-attr', `title=${tooltip}`));
    }
    createSpan() {
        return new UiElements_1.SpanEl()
            .addAttribute('role', 'status')
            .addAttribute('aria-hidden', 'true');
    }
}
exports.SaveModelControls = SaveModelControls;
